import { stringify } from "qs";
import { useQuery } from "@tanstack/react-query";
import { fetch } from "$utils/utils";
import { CacheInvalidationAction } from "$utils/cache";

export const getProductByReference = async (params) => {
  const res = await fetch(`/api/product/withoutCache?${stringify(params)}`);
  return res.data;
};

export const getProductsByReferencesAndCompany = async (
  references: string[],
  companyId: string,
  isReferenced = undefined
) => {
  const res = await fetch("/api/product/getByReferences", {
    method: "POST",
    data: { references, company: companyId, isReferenced },
  });
  return res.data;
};

export const getExportProducts = async (params) => {
  const res = await fetch(`/api/export/products`, {
    method: "POST",
    data: params,
    responseType: "blob",
    timeout: 60000,
  });
  return res.data;
};

export const getProductById = async (id, params = {}) => {
  const res = await fetch(
    `/api/product/withoutCacheById/${id}?${stringify(params)}`
  );
  return res.data;
};

export const getProductStock = async (params) => {
  const { data } = await fetch(
    `/api/product/stockWithoutCache?${stringify(params)}`
  );
  return data;
};

export const useForceRefreshProducts = (
  companyId,
  referencingCategory = null
) => {
  const { data: products, isLoading } = useQuery({
    queryKey: [
      CacheInvalidationAction.GET_PRODUCT_STOCK,
      companyId,
      referencingCategory,
    ],
    queryFn: () =>
      getProductStock({
        company: companyId,
        ...(referencingCategory ? { referencingCategory } : {}),
      }),
    enabled: !!companyId,
    gcTime: 1000 * 60,
  });

  return { products: products?.data, isLoading };
};

export const checkDeactivation = async (
  id: string,
  reference: string,
  companyId: string
) => {
  const res = await fetch(`/api/product/checkDeactivation`, {
    method: "POST",
    data: { productId: id, productReference: reference, companyId },
  });
  return res.data;
};
